import {
  ExerciseTagDto,
  TagDto,
} from "@growth-machine-llc/stridist-api-client";
import React from "react";
import { TagType } from "../../../constants";
import { Box, Card, CardActionArea } from "@mui/material";
import { TagMenu } from "./ExerciseTagMenu";
import TagChip from "./TagChip";

interface ITagCardProps {
  tag: ExerciseTagDto | TagDto;
  onClick?: () => void;
  onEdit?: () => void;
  tagType: TagType;
}

const TagCard = (props: ITagCardProps) => {
  const { tag, onClick, onEdit, tagType } = props;

  return (
    <Card key={tag.id}>
      <CardActionArea
        onClick={onClick}
        sx={{
          padding: 2,
          display: "flex",
          flexDirection: "row",
          gap: 1,
          justifyContent: "space-between",
        }}
      >
        <Box
          display="flex"
          alignItems="flex-start"
          gap={1}
          flexDirection={"column"}
        >
          <TagChip text={tag.title} primaryColor={tag.primaryColor} />
          <Box fontSize={14} color="text.secondary">
            {tag.description}
          </Box>
        </Box>
        <Box onClick={(e) => e.stopPropagation()}>
          <TagMenu tag={tag} onEdit={onEdit} tagType={tagType} />
        </Box>
      </CardActionArea>
    </Card>
  );
};

export default TagCard;
